import React, { useState } from 'react'
import { View } from 'react-native'
import { useDispatch } from 'react-redux'
import { useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Text, IconButton } from '@components/base'
import { FadeFromBottomModal } from '@components'
import { useGoBack } from '@src/utils/navigation'
import { useDispatchAsync } from '@src/utils'
import { useSnack } from '@src/utils/navigatorContext'
import { SurveysConfigKind, UserPropertyKind } from '@src/types'
import { AppStackParamList } from '@navigation/types'

const NO_RATING = '0'

export const RateAppModal = () => {
  const styles = useStyleSheet(themedStyles)
  const showSnack = useSnack()
  const [rating, setRating] = useState(0)
  const dispatchAsync = useDispatchAsync()
  const dispatch = useDispatch()
  const navigation = useNavigation<StackNavigationProp<AppStackParamList>>()

  const goBack = useGoBack()

  const onClose = () => {
    dispatch({
      type: 'users/upsertUserProperty',
      payload: {
        kind: UserPropertyKind.AppRating,
        value: NO_RATING,
      },
    })
    goBack()
  }

  const handlePress = async (index: number) => {
    const rating = index + 1
    setRating(rating)

    try {
      await dispatchAsync({
        type: 'users/upsertUserProperty',
        payload: {
          kind: UserPropertyKind.AppRating,
          value: rating.toString(),
        },
      })
    } catch {
      showSnack('Failed to rate the app. Please try again.', null, 'error')
    }

    if (rating === 5) {
      navigation.replace('PositiveRatingModal')
    } else {
      navigation.replace('Questionnaire', {
        questionnaire: SurveysConfigKind.ConstructiveFeedback,
      })
    }
  }

  return (
    <FadeFromBottomModal closeModal={onClose} contentStyles={styles.content}>
      <View style={styles.container}>
        <Text type="title-2" style={styles.title}>
          How satisfied are you with your experience so far?
        </Text>
        <Text type="regular" style={styles.subtitle}>
          We’d love to know!
        </Text>
        <View style={styles.starsContainer}>
          {Array.from(new Array(5)).map((_, index) => {
            return (
              <IconButton
                type="transparent"
                key={index}
                onPress={() => handlePress(index)}
                iconName="star"
                iconProps={{
                  weight: 'fill',
                  style: rating > index ? styles.selected : styles.notSelected,
                }}
                accessibilityLabel="star-rate"
                size="xl"
              />
            )
          })}
        </View>
      </View>
    </FadeFromBottomModal>
  )
}

const themedStyles = StyleService.create({
  content: {
    backgroundColor: 'theme.background',
  },
  container: {
    marginTop: 8,
  },
  title: {
    textAlign: 'center',
    marginBottom: 16,
  },
  subtitle: {
    textAlign: 'center',
    marginBottom: 16,
    color: 'theme.text.secondary',
  },
  starsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  notSelected: {
    color: 'theme.surface.base1',
  },
  selected: {
    color: 'theme.marketing.yellow',
  },
})
